import * as O from 'fp-ts/Option';
import * as E from 'fp-ts/Either';

import { sequenceT } from 'fp-ts/lib/Apply';

export const sequenceTOption = sequenceT(O.Apply);
export const sequenceTEither = sequenceT(E.Apply);
